import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { AuditSearchRequest, AuditSearchResponse } from 'src/app/shared/models/audit.model';

@Component({
  selector: 'app-audit-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-table #dt [value]="auditEvents().results" dataKey="eventId" [paginator]="true" [filterDelay]="0" [lazy]="true"
      (onLazyLoad)="lazyLoad($event)" [totalRecords]="auditEvents().totalCount"
      [sortField]="auditEvents().originalRequest.sortField" [sortOrder]="auditEvents().originalRequest.sortOrder"
      [rows]="auditEvents().originalRequest.pageSize">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="EventId" class="width80" scope="col">Id <p-sortIcon field="EventId"></p-sortIcon>
          </th>
          <th pSortableColumn="DataEvento" class="width140" scope="col">Data <p-sortIcon field="DataEvento"></p-sortIcon>
          </th>
          <th pSortableColumn="DescrizioneEvento" scope="col">Descrizione <p-sortIcon
              field="DescrizioneEvento"></p-sortIcon>
          </th>
          <th pSortableColumn="PosizioneDocumento" class="width250" scope="col">Fascicolo <p-sortIcon
              field="PosizioneDocumento">
            </p-sortIcon>
          </th>
          <th pSortableColumn="PosizioneUsername" class="width250" scope="col">Username <p-sortIcon
              field="PosizioneUsername">
            </p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-auditEvent>
        <tr class="p-selectable-row">
          <td>
            {{auditEvent.eventId}}
          </td>
          <td>
            {{auditEvent.dataEvento | date:'short':'local':'it_it'}}
          </td>
          <td>
            {{auditEvent.descrizioneEvento}}
          </td>
          <td>
            <app-position-value *ngIf="auditEvent.posizioneHierarchy" [posizione]="auditEvent.posizioneHierarchy">
            </app-position-value>
          </td>
          <td>
            {{auditEvent.userName}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" style="text-align:left">Nessun evento disponibile</td>
        </tr>
      </ng-template>
    </p-table>
  `,
  styles: `
    .width80 { width: 80px; }
    .width140 { width: 140px; }
    .width250 { width: 250px; }
  `
})
export class AuditTableComponent {
  auditEvents = input.required<AuditSearchResponse>();
  updateRequestAndSearch = output<AuditSearchRequest>();

  lazyLoad(event: TableLazyLoadEvent): void {
    const originalRequest = this.auditEvents().originalRequest;
    if (originalRequest.pageFirstRow !== event.first || originalRequest.pageSize !== event.rows ||
      originalRequest.sortField !== event.sortField || originalRequest.sortOrder !== event.sortOrder) {
      const request = {
        pageFirstRow: event.first,
        pageSize: event.rows,
        sortField: event.sortField,
        sortOrder: event.sortOrder,
      } as AuditSearchRequest;
      this.updateRequestAndSearch.emit(request);
    }
  }
}
